import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import trel1 from "../../assets/Images/trello/1.png";
import trel2 from "../../assets/Images/trello/2.png";



import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";



const Lo4Scrum = () => {
    const navigate = useNavigate();

    const images = [trel1, trel2];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Scrum and Summary Process</h1>
                <p>I need to show how I plan my work</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
                        </div>
                        
            <div className="content-lo4">
                <div className="content-lo4-scrum">
                    <div className="content-lo4-scrum-text">
                    
                        <h1>The use of Trello</h1>
                        <p>
                            To plan and managed my work throughout the semester, I followed the scrum framework, Our team uses an agile workflow, using Trello as our main tool
                            to organize task, track progress, and stay aligned with our sprint goals.
                             
                        </p>
                        <h2>Using Trello for Project Planning</h2>
                        <p>
                            Trello served as our digital scrum board, I used it to:
                            <ul>
                                <li>Track individual or group tasks</li>
                                <li>Monitor sprint progress</li>
                                <li>Check off completed items</li>
                                <li>Coordinate with group what was in progress, and what still needed attention</li>
                            </ul>
                            Here is the link for our trello <a href="https://trello.com/invite/b/67cebff220070e8340275383/ATTI598a40f0bc9b626b5f67d245a805d234E0EB1054/semester-3-octolume">Here</a>
                        </p>
                        
                    </div>

                    <div className="content-lo4-scrum-text2">
                    
                        <h1>Project Timeline</h1>
                        <p>
                            Our group was assigned with a real client from Fontys to support the marketing campaign for their new minor, Virtual Production. Over the course of several sprints, we collaborated with Fontys
                            Marketing department to research, ideate, prototype, and present campaign solutions.
                        </p>
                        <h2>Sprint 1 and 2</h2>
                        <p>
                            <ul>
                                <li>conducted research to understand the minor and its context</li>
                                <li>Met our client, Suzette, from the Fontys Marketing team</li>
                                <li>Scheduled and prepared for the first official client meeting</li>
                                <li>Created a shared Git repository</li>
                                <li>Explore basic startegis for promoting minors</li>

                            </ul>
                        </p>
                        
                        <h2>Sprint 3 and 4</h2>
                        <p>
                            <ul>
                                <li>Defined our target audience through interviews and group discussions</li>
                                <li>Conducted a competitor analysis to see how similar programs were marketed</li>
                                <li>Collaborated on “How Might We” (HMW) questions to identify problem spaces</li>
                                <li>Brainstormed our core concept direction</li>
                                <li>Presented our ideas during the concept showcase</li>
                                <li>Contributed to designing the poster for the concept presentation</li>
                                <li>Started writing the Concept Document</li>

                            </ul>
                        </p>
                        
                        <h2>Sprint 5 and 6</h2>
                        <p>
                            <ul>
                                <li>Finalized our campaign concept and received feedback from the client</li>
                                <li>Divide the task among groups</li>
                                <li>I was responsible for creating promotional posters during this phase</li>
                                

                            </ul>
                        </p>
                        
                        <h2>Sprint 7 and 8</h2>
                        <p>
                            <ul>
                                <li>Develop user stories to guide the final delivery</li>
                                <li>Designed and help built the 3D Poster for our campaign</li>
                                <li>Participated in a market display event, where I assisted Adib in presenting and testing our interactive prototype</li>
                                <li>I helped in designing                                                                                Mascot for Marketing Campaign</li>
                                <li>I translate the design to blender</li>
                                <li>I Printed the 3D Mascot design for our poster to make it interactive</li>
                                <li>I replace the old placeholder for the poster, and use the mascot as our brand identity for the campaign</li>
                            </ul>
                        </p>
                        
                        
                    </div>

                    <div className="content-lo4-scrum-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4Scrum;